import { pdf } from "@react-pdf/renderer";

type UsePrintButton = {
  handlePrintPDF: () => void;
};

export const usePdfExport = (element: JSX.Element): UsePrintButton => {
  const handlePrintPDF = async () => {
    try {
      const blob = await pdf(element).toBlob();
      const url = URL.createObjectURL(blob);
      window.open(url, "_blank");
    } catch (error) {
      console.error(error);
    }
  };

  return { handlePrintPDF };
};